export function buildSortQuery(sorter) {
  if (!sorter || !sorter.column) {
    return {};
  }

  return {
    sort_by: sorter.column,
    sort_direction: sorter.asc === false ? 'desc' : 'asc',
  };
}

export function parseSorter(query, defaultColumn = null) {
  const column = query && query.sort_by ? query.sort_by : defaultColumn;
  const direction = query && query.sort_by ? query.sort_direction : 'desc';

  return {
    column,
    asc: direction === 'asc',
  };
}
